import React, { useState } from "react";
import "./OnboardingMenu.scss";
import { IconButton } from "@mui/material";
import {
  DismissIcon,
  CheckmarkCheckedIcon,
  CheckmarkUncheckedIcon,
  MinimizeIcon,
  ExpandIcon,
  OnboardingMenuIcon,
} from "../icons";
import { useDispatch, useSelector } from "react-redux";
import {
  dismissOnboarding,
  selectShowOnboarding,
  selectSelectedProjectId,
  setCheckedItem,
  setActiveSettingsContent,
} from "../../store/slices/onboardingSlice";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../store/store";

const OnboardingMenu: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const showOnboarding = useSelector(selectShowOnboarding);
  const selectedProjectId = useSelector(selectSelectedProjectId);
  const checkedItems = useSelector(
    (state: RootState) => state.onboarding.checkedItems,
  );
  const [isExpanded, setIsExpanded] = useState(true);
  const [isHovered, setIsHovered] = useState(false);

  const handleToggleItem = (
    key: keyof typeof checkedItems,
    checked: boolean,
  ) => {
    console.log("key", key, checked);

    // Only mark as checked if it's currently unchecked
    if (!checked) {
      dispatch(setCheckedItem({ key, value: true }));
    }

    if (key === "triggers") {
      dispatch(setActiveSettingsContent("triggers"));
      navigate(`/project/${selectedProjectId}/settings`);
    } else if (key === "feedbackForms") {
      dispatch(setActiveSettingsContent("feedback"));
      navigate(`/project/${selectedProjectId}/settings`);
    } else if (key === "dashboard") {
      navigate(`/project/${selectedProjectId}`);
    }
  };

  const handleDismiss = () => {
    dispatch(dismissOnboarding());
  };

  if (!showOnboarding) return null;

  return (
    <div
      className={`onboarding-menu ${isExpanded ? "expanded" : "minimized"}`}
      onClick={() => !isExpanded && setIsExpanded(true)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {!isExpanded && (
        <>
          <div className="menu-header ${isHovered ? 'expanded' : 'minimized'}`">
            {isHovered ? (
              <ExpandIcon
                className="expand-icon"
                style={{ paddingBottom: "2px !important" }}
              />
            ) : (
              <OnboardingMenuIcon className="onboarding-menu-icon" />
            )}
          </div>
          <div className="menu-items">
            {Object.entries(checkedItems).map(([key, checked]) => (
              <div key={key} className="checkbox">
                {checked ? (
                  <CheckmarkCheckedIcon />
                ) : (
                  <CheckmarkUncheckedIcon />
                )}
              </div>
            ))}
          </div>
        </>
      )}
      {isExpanded && (
        <>
          <div className="menu-header">
            <span className="title">To-Do</span>
            <IconButton onClick={() => setIsExpanded(false)} size="small">
              <MinimizeIcon />
            </IconButton>
          </div>

          <div className="menu-items-expanded">
            <div className="menu-item">
              <div className="checkbox">
                {checkedItems.triggers ? (
                  <CheckmarkCheckedIcon />
                ) : (
                  <CheckmarkUncheckedIcon />
                )}
              </div>
              <span
                onClick={() =>
                  handleToggleItem("triggers", checkedItems.triggers)
                }
              >
                Review Triggers
              </span>
            </div>

            <div className="menu-item">
              <div className="checkbox">
                {checkedItems.feedbackForms ? (
                  <CheckmarkCheckedIcon />
                ) : (
                  <CheckmarkUncheckedIcon />
                )}
              </div>
              <span
                onClick={() =>
                  handleToggleItem("feedbackForms", checkedItems.feedbackForms)
                }
              >
                Review Feedback Forms
              </span>
            </div>

            <div className="menu-item">
              <div className="checkbox">
                {checkedItems.dashboard ? (
                  <CheckmarkCheckedIcon />
                ) : (
                  <CheckmarkUncheckedIcon />
                )}
              </div>
              <span
                onClick={() =>
                  handleToggleItem("dashboard", checkedItems.dashboard)
                }
              >
                View Dashboard
              </span>
            </div>
          </div>
          <div className="dismiss-button" onClick={handleDismiss}>
            <DismissIcon className="dismiss-icon" />
            Dismiss
          </div>
        </>
      )}
    </div>
  );
};

export default OnboardingMenu;
